/* eslint-disable react-hooks/exhaustive-deps */
import DataGridColumn from "./DataGridColumn";
import { useEffect, useState } from "react";
import { FlexGridCellTemplate } from "@grapecity/wijmo.react.grid";
import { Tooltip, toggleClass, escapeHtml, } from '@grapecity/wijmo';

function DataGridToolTipColumn ( props ) {
    const { schema, ...others } = props;
    const [cellTemplate, setCellTemplate] = useState ((ctx) => {
        return <></>;
    });

    useEffect(() => {
        setCellTemplate(() => ((ctx) => {
            return (
                <div>
                    {ctx.item[schema.name]}
                </div>
            );
        }));

        if(others) {
            let tooltip = new Tooltip();
            others.$parent.control.formatItem.addHandler((flex, element) => {
                if (element.panel === flex.cells) {
                    let item = flex.rows[element.row].dataItem
                    let binding = flex.columns[element.col].binding
                    let data = item[schema.name] ? item[schema.name] : null;
                    toggleClass(element.cell, 'wj-has-notes', binding === schema.name && data !== null );
    
                    if(binding === schema.name && data !== null) {
                        // 말풍선은 HTML 로 그리므로 저장된 값은 글자로 바꿔 넣는다(XSS 방지)
                        let text = "";
                        try {
                            const parsed = JSON.parse(data);
                            text = `<pre>${escapeHtml(JSON.stringify(parsed, null, 2))}</pre>`;
                        } catch {
                            text = `<div>${escapeHtml(data)}</div>`;
                        }
                        tooltip.setTooltip(element.cell, text);
                    }
                }
            })
        }
    }, [schema]);

    return (
        <DataGridColumn schema={schema} {...others}>
            <FlexGridCellTemplate cellType="Cell" template={cellTemplate} />
        </DataGridColumn>
    );
}

export default DataGridToolTipColumn;
